import { module } from './store'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'

export const KEY = 'reservation-timer'

export const ReservationTimer: StorefrontModule = function ({ store }) {
  store.registerModule(KEY, module)
}
